module.exports = __webpack_public_path__ + "static/img/4.eb09fb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/4.png
// module id = 03g5
// module chunks = 0